import DriverDetailsCardContainer from './DriverDetailsCardContainer';

export default DriverDetailsCardContainer;
